import { useEffect, useRef } from 'react';
import axios from 'axios';

const REACT_APP_API_URL = `${process.env.REACT_APP_API_URL}`;
const HEARTBEAT_INTERVAL = 60 * 1000; // 60 seconds

export const useHeartbeat = () => {
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const sendHeartbeat = () => {
      axios.post(`${REACT_APP_API_URL}/activity/heartbeat`).catch(() => {});
    };

    // Send immediately on mount
    sendHeartbeat();

    // Then every 60 seconds
    intervalRef.current = setInterval(sendHeartbeat, HEARTBEAT_INTERVAL);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);
};
